import { Customization } from '@eduvision/toolkit';
import deTranslation from '../translations/de.json';

export const translations: Customization['translations'] = {
	de: deTranslation,
};
